import PropTypes from 'prop-types';

export const propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  levelId: PropTypes.number
};

export const defaultProps = {
  id: null,
  title: null,
  levelId: null
};

export const mapPropTypes = {
  [PropTypes.number]: PropTypes.shape(propTypes)
};

export default { defaultProps, propTypes, mapPropTypes };
